import { Grid, TableCell } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledGridContainer = styled(Grid)`
  padding-top: 5px;
`;

export const StyledTableCell = styled(TableCell)`
  border: 0;
`;